export const ZIP_AUTHORIZED_LENGTHS = {
  SHORT: 5,
  LONG: 9
};

export const ZIP_LENGTH_MESSAGE = () => {
 return `Zip Code must be ${ZIP_AUTHORIZED_LENGTHS.SHORT}
 or ${ZIP_AUTHORIZED_LENGTHS.LONG} characters long`;
};

export const PHONE_AUTHORIZED_LENGTH = 10;
export const PHONE_LENGTH_MESSAGE = () => `Phone must be ${PHONE_AUTHORIZED_LENGTH} digits long`;

export const LOOKUP_DESCRIPTION = "Enter your client's Business Name into the search box below, then select from the available options.";
